import React, { useState, useEffect, Fragment } from 'react';
import styles from '../../assets/css/module/common.module.css';
import { IsNotNull, getLeaveRequestTypeValue } from '../../helpers/helper';
import dayjs from 'dayjs';
import { XLg, Calendar2CheckFill } from 'react-bootstrap-icons';

const LeaveController = require('../../controllers/employee/permissions/leave');

const PILL_COLORS = {
  1:   { bg: 'linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%)' },
  2:   { bg: 'linear-gradient(135deg, #881337 0%, #e11d48 100%)' },
  3:   { bg: 'linear-gradient(135deg, #064e3b 0%, #059669 100%)' },
  98:  { bg: 'linear-gradient(135deg, #78350f 0%, #d97706 100%)' },
  99:  { bg: 'linear-gradient(135deg, #3b0764 0%, #7c3aed 100%)' },
  100: { bg: 'linear-gradient(135deg, #0f172a 0%, #334155 100%)' },
}

const getPillStyle = (lType) => {
  const c = PILL_COLORS[lType] || PILL_COLORS[100]
  return { background: c.bg, border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.18), 0 2px 4px rgba(0,0,0,0.10)' }
}

const getPillTextStyle = () => ({ color: 'rgba(255,255,255,0.75)' })

const getPillCountStyle = () => ({ color: '#ffffff' })

const DetailLeaveRequest = ({ modal1, toggleHandler, ObjDetail }) => {
  const [objDetail, setObjDetail] = useState(null)
  const [summary, setSummary] = useState(null)
  const [histLog, setHistLog] = useState(null)

  async function getLeaveRequestSummary(b) {
    LeaveController.getLeaveRequestSummary(b).then(x => {
      setSummary(x)
    })
  }

  async function getLeaveRequestHistoryLog(b) {
    LeaveController.getLeaveRequestHistoryLog(b).then(x => {
      setHistLog(x)
    })
  }

  useEffect(() => {
    setObjDetail(ObjDetail)
    if (IsNotNull(ObjDetail)) {
      let b = { p1: ObjDetail.l_e_id }
      getLeaveRequestSummary(b)
      getLeaveRequestHistoryLog(b)
    }
  }, [])

  function getStatusMini(status) {
    if (status === 2) return (
      <span className={`${styles['modern-status-mini']} ${styles['modern-status-mini-approved']}`}>
        Disetujui
      </span>
    )
    if (status === 3) return (
      <span className={`${styles['modern-status-mini']} ${styles['modern-status-mini-rejected']}`}>
        Ditolak
      </span>
    )
    return (
      <span className={`${styles['modern-status-mini']} ${styles['modern-status-mini-pending']}`}>
        Belum Diproses
      </span>
    )
  }

  if (!modal1) return null

  const totalDays = IsNotNull(objDetail) ? objDetail.total_days_request_in_year : 0

  return (
    <Fragment>
      <div className={styles['modern-modal-overlay']} onClick={toggleHandler}>
        <div className={styles['modern-modal']} onClick={e => e.stopPropagation()}>
          <div className={styles['modern-modal-header']}>
            <div>
              <div className={styles['modern-modal-title-label']}>Histori Cuti / Izin</div>
              <div className={styles['modern-modal-employee']}>
                {IsNotNull(objDetail) ? objDetail.e_name : '—'}
              </div>
            </div>
            <button className={styles['modern-modal-close-btn']} onClick={toggleHandler}>
              <XLg size={14} />
            </button>
          </div>
          <div className={styles['modern-modal-body']}>
            <div className={`${styles['modern-total-card']} py-4`}>
              <div>
                <div className={styles['modern-total-label-sm']}>
                  {`Total Disetujui ${dayjs().format('YYYY')}`}
                </div>
                <div className={styles['modern-total-count']}>{totalDays}</div>
              </div>
              <Calendar2CheckFill size={52} className={styles['modern-total-icon']} />
            </div>
            {IsNotNull(summary) && summary.length > 0 && (
              <div>
                <div className={styles['modern-hist-section-label']}>Ringkasan per Tipe</div>
                <div className={styles['modern-summary-grid']}>
                  {summary.map((x, i) => (
                    <div key={i} className={styles['modern-summary-pill']} style={getPillStyle(x.l_type)}>
                      <span className={styles['modern-summary-type']} style={getPillTextStyle()}>
                        {getLeaveRequestTypeValue(x.l_type)}
                      </span>
                      <span className={styles['modern-summary-count']} style={getPillCountStyle()}>{x.count}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {IsNotNull(histLog) && histLog.length > 0 && (
              <div>
                <div className={styles['modern-hist-section-label']}>Riwayat Pengajuan</div>
                <div className={styles['modern-hist-table-wrap']}>
                  <table className={styles['modern-hist-table']}>
                    <thead>
                      <tr>
                        <th>Tanggal</th>
                        <th>Tipe</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {histLog.map((x, i) => (
                        <tr key={i}>
                          <td>{dayjs(x.dt).format('DD MMM YYYY')}</td>
                          <td>{getLeaveRequestTypeValue(x.l_type)}</td>
                          <td>{getStatusMini(x.l_status)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default DetailLeaveRequest;